// src/modules/fichajes/index.js
const state = {
  ultimoFichaje: null,
  resumenHoy: null,
  estadoActual: "sin_fichajes",
  fichajesToday: [],
  estadosUsuarios: [],
  pendientesValidacion: [],
  jornadasAnuales: [], // NUEVO: Jornadas del año
  detalleJornada: null, // NUEVO: Detalle de una jornada específica
};

const mutations = {
  setUltimoFichaje(state, fichaje) {
    state.ultimoFichaje = fichaje;
  },

  setResumenHoy(state, resumen) {
    state.resumenHoy = resumen;
  },

  setEstadoActual(state, estado) {
    state.estadoActual = estado;
  },

  setFichajesToday(state, fichajes) {
    state.fichajesToday = fichajes;
  },

  setEstadosUsuarios(state, estados) {
    state.estadosUsuarios = estados;
  },

  setPendientesValidacion(state, pendientes) {
    state.pendientesValidacion = pendientes;
  },

  // NUEVO: Mutaciones para jornadas laborales
  setJornadasAnuales(state, jornadas) {
    state.jornadasAnuales = jornadas;
  },

  setDetalleJornada(state, jornada) {
    state.detalleJornada = jornada;
  },

  resetFichajes(state) {
    state.ultimoFichaje = null;
    state.resumenHoy = null;
    state.estadoActual = "sin_fichajes";
    state.fichajesToday = [];
  },
};

const actions = {
  async cargarUltimoFichaje({ commit, rootState }) {
    try {
      const token = rootState.auth.usrLogin.token;
      if (!token) {
        console.error("Token no disponible");
        return;
      }

      const response = await this._vm.axios.get(
        `fichajes/ultimo_fichaje/${token}`
      );

      if (response.data.code_state === 200) {
        commit("setUltimoFichaje", response.data.fichaje);
        commit("setEstadoActual", response.data.estado);
      }
    } catch (error) {
      console.error("Error al cargar último fichaje:", error);
    }
  },

  async cargarResumenHoy({ commit, rootState }) {
    try {
      const token = rootState.auth.usrLogin.token;
      if (!token) {
        console.error("Token no disponible");
        return;
      }

      const response = await this._vm.axios.get(
        `fichajes/resumen_hoy/${token}`
      );

      if (response.data.code_state === 200) {
        commit("setResumenHoy", response.data.resumen);
        commit("setFichajesToday", response.data.fichajes);
      }
    } catch (error) {
      console.error("Error al cargar resumen de hoy:", error);
    }
  },

  async fichar({ dispatch, rootState }, { tipo, notas }) {
    try {
      const token = rootState.auth.usrLogin.token;
      if (!token) {
        return {
          success: false,
          error: "No hay sesión activa. Por favor, inicia sesión.",
        };
      }

      const response = await this._vm.axios.post(`fichajes/fichar/${token}`, {
        tipo,
        notas,
      });

      if (response.data.code_state === 200) {
        await dispatch("cargarUltimoFichaje");
        await dispatch("cargarResumenHoy");
        return { success: true, data: response.data };
      } else {
        return { success: false, error: response.data.error };
      }
    } catch (error) {
      console.error("Error completo al fichar:", error);
      return {
        success: false,
        error: error.response?.data?.error || "Error al fichar",
      };
    }
  },

  async cargarEstadosUsuarios({ commit, rootState }) {
    try {
      const token = rootState.auth.usrLogin.token;
      if (!token) {
        console.error("Token no disponible");
        return;
      }

      const response = await this._vm.axios.get(
        `fichajes/estado_actual/${token}`
      );

      if (response.data.code_state === 200) {
        commit("setEstadosUsuarios", response.data.estados);
      }
    } catch (error) {
      console.error("Error al cargar estados:", error);
    }
  },

  async cargarPendientesValidacion({ commit, rootState }) {
    try {
      const token = rootState.auth.usrLogin.token;
      if (!token) {
        console.error("Token no disponible");
        return;
      }

      const response = await this._vm.axios.get(
        `fichajes/pendientes_validacion/${token}`
      );

      if (response.data.code_state === 200) {
        commit("setPendientesValidacion", response.data.pendientes);
      }
    } catch (error) {
      console.error("Error al cargar pendientes:", error);
    }
  },

  async validarResumen({ dispatch, rootState }, { resumen_id, observaciones }) {
    try {
      const token = rootState.auth.usrLogin.token;
      if (!token) {
        return { success: false, error: "Token no disponible" };
      }

      const response = await this._vm.axios.post(
        `fichajes/validar_resumen/${token}`,
        { resumen_id, observaciones }
      );

      if (response.data.code_state === 200) {
        await dispatch("cargarPendientesValidacion");
        return { success: true, data: response.data };
      } else {
        return { success: false, error: response.data.error };
      }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "Error al validar",
      };
    }
  },

  async rechazarResumen({ dispatch, rootState }, { resumen_id, motivo }) {
    try {
      const token = rootState.auth.usrLogin.token;
      if (!token) {
        return { success: false, error: "Token no disponible" };
      }

      const response = await this._vm.axios.post(
        `fichajes/rechazar_resumen/${token}`,
        { resumen_id, motivo }
      );

      if (response.data.code_state === 200) {
        await dispatch("cargarPendientesValidacion");
        return { success: true, data: response.data };
      } else {
        return { success: false, error: response.data.error };
      }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "Error al rechazar",
      };
    }
  },

  // NUEVO: Cargar jornadas laborales de un año
  async cargarJornadasAnuales({ commit, rootState }, anyo) {
    try {
      const token = rootState.auth.usrLogin.token;
      if (!token) {
        console.error("Token no disponible");
        return { success: false, error: "Token no disponible" };
      }

      const response = await this._vm.axios.get(
        `fichajes/jornadas/${anyo}/${token}`
      );

      if (response.data.code_state === 200) {
        commit("setJornadasAnuales", response.data.jornadas);
        return { success: true, data: response.data };
      } else {
        return { success: false, error: response.data.error };
      }
    } catch (error) {
      console.error("Error al cargar jornadas:", error);
      return {
        success: false,
        error: error.response?.data?.error || "Error al cargar jornadas",
      };
    }
  },

  // NUEVO: Cargar detalle de una jornada específica
  async cargarDetalleJornada({ commit, rootState }, jornadaId) {
    try {
      const token = rootState.auth.usrLogin.token;
      if (!token) {
        console.error("Token no disponible");
        return { success: false, error: "Token no disponible" };
      }

      const response = await this._vm.axios.get(
        `fichajes/detalle_jornada/${jornadaId}/${token}`
      );

      if (response.data.code_state === 200) {
        commit("setDetalleJornada", response.data.jornada);
        return { success: true, data: response.data };
      } else {
        return { success: false, error: response.data.error };
      }
    } catch (error) {
      console.error("Error al cargar detalle de jornada:", error);
      return {
        success: false,
        error: error.response?.data?.error || "Error al cargar detalle",
      };
    }
  },
};

const getters = {
  puedeTrabajar: (state) => {
    return ["sin_fichajes", "fuera"].includes(state.estadoActual);
  },

  estaTrabajando: (state) => {
    return state.estadoActual === "trabajando";
  },

  estaEnPausa: (state) => {
    return state.estadoActual === "en_pausa";
  },

  horasTrabajadas: (state) => {
    if (!state.resumenHoy || !state.resumenHoy.minutos_trabajados)
      return "0h 0m";
    const minutos = state.resumenHoy.minutos_trabajados;
    const horas = Math.floor(minutos / 60);
    const mins = minutos % 60;
    return `${horas}h ${mins}m`;
  },

  totalPendientes: (state) => {
    return state.pendientesValidacion.length;
  },

  // NUEVO: Getters para jornadas
  jornadasValidadas: (state) => {
    return state.jornadasAnuales.filter((j) => j.estado === "validada");
  },

  jornadasPendientes: (state) => {
    return state.jornadasAnuales.filter(
      (j) => j.estado === "pendiente_validacion"
    );
  },

  jornadasIncompletas: (state) => {
    return state.jornadasAnuales.filter((j) => j.estado === "incompleta");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
